import _get from 'lodash/get';
import _map from 'lodash/map';
import _values from 'lodash/values';
import _isEmpty from 'lodash/isEmpty';
import { Row, RenderConfig, TextInput, SelectInput, NumberInput } from 'commons-ui';
import { FORM_FIELD_KEYS } from './constants';
import { TOPIC_NAMES, TOPIC_NAME_LABLES, TOPIC_NAME_OPTIONS, topicSubtopicMap } from '../../constants';

const subTopicDepResolver = (props: any, dependencyValues: any) => {
	const topic: string = _get(dependencyValues, '0');
	if (_isEmpty(topic) && _isEmpty(topic)) {
		return { defaultValues: [] };
	}
	if (!_isEmpty(topic) || !_isEmpty(topic)) {
		return { options: _map(_values(topicSubtopicMap[topic]), (scope) => ({ id: scope, label: scope })) };
	}
	return null;
};

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.TOPIC_NAME]: new RenderConfig()
		.setName('topicId')
		.setLabel('Topic')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true,
			options: _map(_values(TOPIC_NAMES), (topic) => ({
				id: _get(TOPIC_NAME_OPTIONS, topic),
				label: _get(TOPIC_NAME_LABLES, topic)
			}))
		}),
	[FORM_FIELD_KEYS.SUB_TOPIC_NAME]: new RenderConfig()
		.setName('subTopicId')
		.setLabel('Sub Topic')
		.setRenderer(SelectInput)
		.setRenderProps({
			options: [],
			required: true,
			isEditable: { create: true, edit: true },
			dependencies: ['topicId'],
			dependencyResolver: subTopicDepResolver
		}),
	[FORM_FIELD_KEYS.TRANSACTION_ID]: new RenderConfig()
		.setName('transactionId')
		.setLabel('Transaction Id')
		.setRenderer(NumberInput)
		.setRenderProps({
			isEditable: { create: true, edit: true }
		}),
	[FORM_FIELD_KEYS.ENTRY_FEE]: new RenderConfig()
		.setName('entryFee')
		.setLabel('Entry Fee')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true }
		}),
	[FORM_FIELD_KEYS.DESCRIPTION]: new RenderConfig()
		.setName('description')
		.setLabel('Description')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true
		})
};

export const FORM_LAYOUT_CONFIG = [
	new Row(FORM_FIELD_KEYS.TOPIC_NAME),
	new Row(FORM_FIELD_KEYS.SUB_TOPIC_NAME),
	new Row(FORM_FIELD_KEYS.TRANSACTION_ID),
	new Row(FORM_FIELD_KEYS.ENTRY_FEE),
	new Row(FORM_FIELD_KEYS.DESCRIPTION)
];
